export default __webpack_public_path__ + "static/EYInterstateBold-d78c5e855974ad102c43ac9a21663985.woff2";